var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg16HeadphoneStand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M321.461 449.065L316.655 451.913L314.437 454.761L312.219 486.799L312.588 498.547L319.243 496.411L320.721 493.919L319.243 452.269L321.461 449.065Z",
    fill: "#DECCC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.159 446.574L349.558 465.441L321.462 450.846L315.547 449.778L320.353 446.93L325.159 446.574Z",
    fill: "#FDFAF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.16 446.574L320.354 449.422L349.56 465.441L353.996 462.949L325.16 446.574Z",
    fill: "#FDFAF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M349.584 467.685L349.584 465.746L353.945 463.484L353.945 465.1L349.584 467.685Z",
    fill: "#E1DCD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.921 501.395L320.721 493.919L318.503 497.123L312.588 498.547L325.527 507.091L327.376 507.447L335.509 502.819L332.921 501.395Z",
    fill: "#FDFAF7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.376 497.835L320.721 493.919L312.588 498.547L327.376 497.835Z",
    fill: "#DECCC2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.557 467.221L320.721 451.558L316.654 451.914L314.436 454.762L312.588 498.547L324.788 506.023L327.375 507.447L327.375 508.515L310 498.903L312.588 453.694L315.176 449.778L315.545 449.778L320.351 449.422L349.557 465.441L349.557 467.221Z",
    fill: "#F7F4EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M335.509 503.887L327.376 508.515L327.376 507.447L335.509 502.819L335.509 503.887Z",
    fill: "url(#paint0_linear_2013_1094)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2013_1094",
    x1: 330.72,
    y1: 504.696,
    x2: 332.399,
    y2: 507.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDCCC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6A17A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg16HeadphoneStand);
export default __webpack_public_path__ + "static/media/16HeadphoneStand.4e6fc0f4ee31f41eef3696934b7b6923.svg";
export { ForwardRef as ReactComponent };